import { Link } from 'react-router-dom'
import classNames from 'classnames'

import AnimatedCard from '../ui/AnimatedCard/AnimatedCard'
import Title from '../ui/Title/Title'
import ScrollHandler from '../ui/ScrollHandler/ScrollHandler'
import useHorizontalScroll from '../../hooks/useHorizontalScroll'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import {
  downloadDocument,
  getImageUrl,
  isArabic,
  viewDocument,
} from '../../utils'
import view from '../../assets/images/view.svg'
import download from '../../assets/images/download.svg'
import styles from './GlobalMedia.module.scss'
import Image from '../ui/Image/Image'

function GlobalMedia({ widgetDetails }) {
  const { title: heading = '', link, media = [] } = widgetDetails
  const { language } = useLanguage()
  const { scrollRef, scrollLeft, scrollRight, isAtStart, isAtEnd } =
    useHorizontalScroll()

  const viewPdfHandler = (pdfDetails = {}) => {
    viewDocument(pdfDetails?.url || '')
  }

  const downloadPdfHandler = (pdfDetails = {}) => {
    downloadDocument(pdfDetails?.name, pdfDetails?.url || '')
  }

  const renderBottomAnimation = (item) => (
    <div className={classNames(styles.imagesContainer)}>
      <img
        src={view}
        alt={'View'}
        className={classNames('block', styles.imgLogo)}
        onClick={() => viewPdfHandler(item?.pdfDetails)}
      />
      <img
        src={download}
        alt="Download"
        className={classNames('block', styles.imgLogo)}
        onClick={() => downloadPdfHandler(item?.pdfDetails)}
      />
    </div>
  )

  return (
    <div
      className={classNames(styles.rootContainer, {
        [styles.arabicRootContainer]: isArabic(language?.code),
      })}
    >
      <div className={classNames('page-container', styles.headingContainer)}>
        <h1 className={styles.heading}>{heading}</h1>
        <div className={styles.linkContainer}>
          <Link to={link?.path}>{link?.label}</Link>
          {!(isAtStart && isAtEnd) && (
            <ScrollHandler
              scrollLeftHandler={scrollLeft}
              scrollRightHandler={scrollRight}
              isAtEnd={isAtEnd}
              isAtStart={isAtStart}
              className={styles.scrollHandler}
            />
          )}
        </div>
      </div>
      <div ref={scrollRef} className={classNames(styles.cardContainer)}>
        {media.map((item) => (
          <AnimatedCard
            key={'media' + item?.id}
            cardClassname={styles.rootCardContainer}
            renderBottomAnimation={() => renderBottomAnimation(item)}
            bottomAnimationClassName={classNames(styles.bottomAnimation)}
          >
            <div className={styles.cardInnerContainer}>
              <div className={styles.cardTopContainer}>
                <Title classname={styles.cardTitle}>{item.title}</Title>
                <div className={styles.mediaContainer}>
                  <Image
                    src={getImageUrl(item?.mediaimage)}
                    alt={item?.mediaimage?.name}
                  />
                  <span>{item?.mediaheading}</span>
                </div>
              </div>
              {item?.publishedDate && (
                <div className={styles.dateContainer}>
                  <span>
                    {item?.publishedDate}
                    {`${item?.timeToRead && ' | ' + item.timeToRead}`}
                  </span>
                </div>
              )}
            </div>
          </AnimatedCard>
        ))}
      </div>
    </div>
  )
}

export default GlobalMedia
